import { Subject } from 'rxjs/Subject';
import SockJS from 'sockjs-client';
import { Client, Message, over } from 'stompjs';
import { environment } from '../../../../environments/environment';
import { parse } from '../../utils/object.utils';
import { getSession } from '../storage.service';
import { HistoricalErpSynchronizationBuilder } from './../../models/builders/historical-erp-synchronization.builder';

const TIMEOUT_STEP = 5000; // 5 seconds
const TIMEOUT_MAX = 30000; // 5 minutes

export class ApiSocketService {
  private stompClient: Client;

  getLastSyncTime() {
    const statusUpdates = new Subject();
    const getLastSyncTimeUpdate = () => {
      this.stompClient.subscribe('/topic/last-sync', (message: Message) => {
        statusUpdates.next(HistoricalErpSynchronizationBuilder.fromJson(parse(message.body)));
      });
    };
    this.connect(getLastSyncTimeUpdate);

    return statusUpdates;
  }

  disconnect() {
    if (this.stompClient.connected) {
      this.stompClient.disconnect(() => {}); // tslint:disable-line:no-empty
    }
  }

  private connect = (callback: (frame: any) => void, timeout = TIMEOUT_STEP) => {
    const session = getSession();
    const ws = new SockJS(`${ environment.socketUrl }?token=${ session.token }`);
    this.stompClient = over(ws);
    if (environment.production) {
      this.stompClient.debug = () => {}; // tslint:disable-line:no-empty
    }

    this.stompClient.connect({}, callback, () => {
      const ts = Math.min(TIMEOUT_MAX, timeout + TIMEOUT_STEP);
      setTimeout(() => {
        this.connect(callback, ts);
      }, timeout);
    });
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/api-socket.service.ts